import Vue from "vue";
import Vuex from "vuex";
import ApiCaller from "../utils/apicaller";
import types from "./types";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sellgoldStatus: [],
    userDetail: null,
    goldDetail: null,
    isAuthorized: true,
    paymentDetail: null,
    addresses: []
  },

  mutations: {
    [types.AUTHORIZED]: (state, payload) => {
      state.isAuthorized = payload;
    },

    [types.USERDETAIL]: (state, payload) => {
      state.userDetail = payload;
    },

    [types.BUYPRICE]: (state, payload) => {
      state.goldDetail = payload;
    },

    [types.PAYMENTDETAIL]: (state, payload) => {
      state.paymentDetail = payload;
    },

    [types.ADDRESSES]: (state, payload) => {
      state.addresses = payload;
    }
  },

  getters: {
    user: state => {
      return state.userDetail;
    },
    gold: state => {
      return state.goldDetail;
    },

    isUserAuthorized: state => {
      return state.isAuthorized;
    },
    useraddress: state => {
      return state.addressform;
    },
    addresses: state => {
      return state.addresses;
    }
  },

  actions: {
    getUserDetails({ commit }, { type, payload }) {
      return ApiCaller("accounts/user_status/", "get");
    },

    saveUser({ commit }, { type, payload }) {
      return ApiCaller("accounts/user_registration/", "post", payload);
    },

    buyPrice({ commit }, { type, payload }) {
      return ApiCaller("buy_management/buy_price/", "get");
    },

    buyVerification({ commit }, { type, payload }) {
      return ApiCaller("buy_management/buy_verification/", "post", payload);
    },

    buyConfirmation({ commit }, { type, payload }) {
      return ApiCaller("buy_management/buy_confirmation/", "post", payload);
    },

    sellConfirmation({ commit }, { type, payload }) {
      return ApiCaller("sell_confirmation/v2/", "post", payload);
    },

    getGoldAmount({ commit }, { type, payload }) {
      return ApiCaller("get_gold_amount/", "get");
    },

    getTransactions({ commit }, { type, payload }) {
      return ApiCaller(`accounts/history/v2/${payload}/5`, "get");
    },

    sellVerifaction({ commit }, { type, payload }) {
      return ApiCaller("sell_verification/", "post", payload);
    },

    deliveryGoldProducts({ commit }, { type, payload }) {
      return ApiCaller(`delivery_management/gold_products/${payload}/6`, "get");
    },

    deliveryProductDetail({ commit }, { type, payload }) {
      return ApiCaller(
        `delivery_management/product_list?product_id=${payload}`,
        "get"
      );
    },

    userAddressDetail({ commit }, { type, payload }) {
      return ApiCaller("delivery_management/address_details/", "get");
    },

    updateAddress({ commit }, { type, payload }) {
      return ApiCaller("delivery_management/address_update/", "post", payload);
    },

    createNewAddress({ commit }, { type, payload }) {
      return ApiCaller(
        "delivery_management/create_new_address/",
        "post",
        payload
      );
    },

    deliveryVerification({ commit }, { type, payload }) {
      return ApiCaller(
        `delivery_management/delivery_verification/`,
        "post",
        payload
      );
    },

    deliveryConfirmation({ commit }, { type, payload }) {
      return ApiCaller(
        "delivery_management/delivery_confirmation/",
        "post",
        payload
      );
    },

    gifting({ commit }, { type, payload }) {
      return ApiCaller("tiping_management/gold_tiping/", "post", payload);
		},
		
		giftingHistory({ commit }, { type, payload }) {
      return ApiCaller("tiping_management/tiping_history/", "get");
    },

    myOrdersList({ commit }, { type, payload }) {
      return ApiCaller("delivery_management/order_status/", "get");
    }
  }
});
